module.exports = __webpack_public_path__ + "static/media/logo.cdd760a1.png";